export const BASE_CHIP_CLASS =
  "px-1 md:px-1.5 flex items-center h-5 md:h-6 overflow-hidden rounded-4";

export const BASE_TEXT_CLASS = "body-sm md:body-md";
